﻿export function isValidAccountNumber(accountNumberElement: HTMLInputElement): boolean {
    let isValid = false;

    if (accountNumberElement.value == "") {
        isValid = false;
    } else {
        isValid = accountNumberElement.checkValidity();
    }

    return isValid;
}

export function isValidPin(pinElement: HTMLInputElement): boolean {
    return !pinElement.validity.valueMissing && !pinElement.validity.patternMismatch;
}
